import type { GatewayConfig } from '@/core/api'

const resolveEnvGatewayConfig = (): GatewayConfig | null => {
  const gatewayUrl = process.env.NEXT_PUBLIC_GATEWAY_URL?.trim() ?? ''

  if (!gatewayUrl) {
    return null
  }

  const gatewayPort = process.env.NEXT_PUBLIC_GATEWAY_PORT?.trim() ?? ''
  const gatewaySecured = (process.env.NEXT_PUBLIC_GATEWAY_SECURED?.trim() ?? '') === 'true'

  if (gatewayUrl.startsWith('http://') || gatewayUrl.startsWith('https://')) {
    const parsedUrl = new URL(gatewayUrl)

    return {
      host: parsedUrl.hostname,
      port: gatewayPort || parsedUrl.port || undefined,
      isSecured: parsedUrl.protocol === 'https:',
    }
  }

  return {
    host: gatewayUrl,
    port: gatewayPort || undefined,
    isSecured: gatewaySecured,
  }
}

/**
 * Resolves gateway config from env vars, or in development falls back to current host/port.
 * When no env config is set, uses Next.js API routes host in the browser.
 */
export const getGatewayConfig = (): GatewayConfig => {
  const envGatewayConfig = resolveEnvGatewayConfig()

  if (envGatewayConfig) {
    return envGatewayConfig
  }

  if (typeof window === 'undefined') {
    return { host: '', isSecured: false }
  }

  const [host, port] = window.location.host.split(':')
  return {
    host: `${host ?? 'localhost'}`,
    port: port,
    isSecured: window.location.protocol === 'https:',
  }
}
